<div class="w-full max-w-[860px] p-0">

  <!-- Header -->
  <div style="display: flex; align-items: center; gap: 12px; padding: 20px 24px; border-bottom: 1px solid #e5e7eb;">
    <div style="background: #fef2f2; border-radius: 12px; padding: 10px; display: flex; align-items: center; justify-content: center;">
      <mat-icon style="color: #b91c1c; font-size: 24px; width: 24px; height: 24px;">report_problem</mat-icon>
    </div>
    <div style="flex: 1;">
      <h2 style="margin: 0; font-size: 1.2rem; font-weight: 700; color: #111827;">Casos de pago abiertos</h2>
      <p style="margin: 2px 0 0 0; font-size: 0.8rem; color: #6b7280;">
        Pagos que el banco devolvió, o que nunca aparecieron en la cartola. Cada uno espera una decisión.
      </p>
    </div>
    <button (click)="cerrar()" aria-label="Cerrar"
      style="background: none; border: none; cursor: pointer; color: #9ca3af; display: flex;">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div style="padding: 16px 24px; max-height: 65vh; overflow-y: auto;">

    <!-- Cargando -->
    <div *ngIf="cargando" style="display: flex; align-items: center; gap: 10px; padding: 32px 0; justify-content: center;">
      <mat-spinner diameter="22"></mat-spinner>
      <span style="font-size: 0.85rem; color: #6b7280;">Cargando casos...</span>
    </div>

    <!-- Error -->
    <div *ngIf="!cargando && error"
      style="padding: 14px 16px; background: #fef2f2; border: 1px solid #fecaca; border-radius: 10px; color: #b91c1c; font-size: 0.85rem; display: flex; align-items: center; gap: 10px;">
      <mat-icon style="font-size: 18px; width: 18px; height: 18px;">error_outline</mat-icon>
      <span style="flex: 1;">{{ error }}</span>
      <button (click)="cargar()"
        style="padding: 6px 14px; background: white; color: #b91c1c; border: 1px solid #fecaca; border-radius: 8px; font-size: 0.8rem; font-weight: 600; cursor: pointer;">
        Reintentar
      </button>
    </div>

    <!-- Sin casos: es el estado bueno, y conviene que se lea como tal -->
    <div *ngIf="!cargando && !error && casos.length === 0"
      style="padding: 40px 0; text-align: center;">
      <mat-icon style="font-size: 44px; width: 44px; height: 44px; color: #bbf7d0;">check_circle</mat-icon>
      <p style="margin: 10px 0 0 0; font-weight: 700; color: #15803d;">No hay casos abiertos</p>
      <p style="margin: 4px 0 0 0; font-size: 0.82rem; color: #6b7280;">Todos los pagos del riel están respaldados.</p>
    </div>

    <!-- Casos -->
    <div *ngFor="let caso of casos"
      style="border: 1px solid #e5e7eb; border-radius: 12px; padding: 16px; margin-bottom: 14px; background: white;">

      <!-- Fila 1: que paso y cuanto -->
      <div style="display: flex; align-items: flex-start; gap: 10px; flex-wrap: wrap;">
        <span style="padding: 4px 10px; border-radius: 999px; font-size: 0.7rem; font-weight: 800; text-transform: uppercase; letter-spacing: 0.4px;"
          [style.background]="fondoDe(caso)"
          [style.color]="colorDe(caso)">
          {{ tituloDe(caso) }}
        </span>
        <span style="font-size: 0.75rem; color: #6b7280;">
          Transacción <strong style="color: #374151;">{{ caso.transaccionId }}</strong>
          · Ref N58 {{ caso.referencia }}
        </span>
        <span style="margin-left: auto; font-size: 1.05rem; font-weight: 800; color: #111827;">
          {{ formatearMonto(caso.montoOrigen, caso.monedaOrigen || '') }}
        </span>
      </div>

      <!-- Fila 2: de quien es -->
      <div class="grid" style="grid-template-columns: 1fr 1fr; gap: 12px; margin-top: 12px;">
        <div>
          <div style="font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; color: #9ca3af;">Cliente</div>
          <div style="font-size: 0.88rem; font-weight: 600; color: #111827;">{{ caso.cliente || '—' }}</div>
          <div style="font-size: 0.75rem; color: #6b7280;">{{ caso.emailCliente }}</div>
        </div>
        <div>
          <div style="font-size: 0.68rem; font-weight: 700; text-transform: uppercase; letter-spacing: 0.4px; color: #9ca3af;">Beneficiario</div>
          <div style="font-size: 0.88rem; font-weight: 600; color: #111827;">{{ caso.beneficiario || '—' }}</div>
          <div style="font-size: 0.75rem; color: #6b7280;">{{ caso.cuentaBeneficiario }}</div>
        </div>
      </div>

      <!-- Las dos pruebas de que el pago salio. El backend ya las mandaba y no se
           mostraban: el 01/10 hubo 11 casos con las dos en verde y nadie podia verlo -->
      <div style="display: flex; gap: 8px; flex-wrap: wrap; margin-top: 12px;">
        <span style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 999px; font-size: 0.72rem; font-weight: 700;"
          [style.background]="caso.tieneRenglon ? '#f0fdf4' : '#f3f4f6'"
          [style.color]="caso.tieneRenglon ? '#15803d' : '#6b7280'">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px;">{{ caso.tieneRenglon ? 'check_circle' : 'help_outline' }}</mat-icon>
          {{ caso.tieneRenglon ? 'Está en la cartola' : 'No está en la cartola' }}
        </span>
        <span *ngIf="caso.liquidado !== undefined"
          style="display: inline-flex; align-items: center; gap: 4px; padding: 3px 10px; border-radius: 999px; font-size: 0.72rem; font-weight: 700;"
          [style.background]="caso.liquidado ? '#f0fdf4' : '#f3f4f6'"
          [style.color]="caso.liquidado ? '#15803d' : '#6b7280'">
          <mat-icon style="font-size: 14px; width: 14px; height: 14px;">{{ caso.liquidado ? 'check_circle' : 'help_outline' }}</mat-icon>
          {{ caso.liquidado ? 'El banco lo confirmó' : 'El banco no lo confirmó' }}
        </span>
      </div>

      <!-- Evidencia: lo que el sistema ya averiguo, para no ir a buscarlo -->
      <div *ngIf="caso.evidencia"
        style="margin-top: 12px; padding: 10px 12px; background: #fffbeb; border: 1px solid #fde68a; border-radius: 8px; font-size: 0.8rem; color: #92400e; display: flex; gap: 8px;">
        <mat-icon style="font-size: 16px; width: 16px; height: 16px; flex-shrink: 0;">lightbulb</mat-icon>
        <span>{{ caso.evidencia }}</span>
      </div>

      <!-- Por que el boton de reversar no va. Se muestra, no se esconde el caso -->
      <div *ngIf="!caso.reversable && caso.motivoNoReversable"
        style="margin-top: 10px; font-size: 0.78rem; color: #6b7280; display: flex; gap: 6px; align-items: flex-start;">
        <mat-icon style="font-size: 15px; width: 15px; height: 15px; flex-shrink: 0;">block</mat-icon>
        <span>{{ caso.motivoNoReversable }}</span>
      </div>

      <!-- Acciones -->
      <div style="display: flex; gap: 10px; margin-top: 14px; flex-wrap: wrap;">
        <button (click)="reversar(caso)" [disabled]="!caso.reversable || procesando === caso.id"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #b91c1c; color: white; border: none; border-radius: 8px; font-size: 0.82rem; font-weight: 700; cursor: pointer;"
          [style.opacity]="!caso.reversable || procesando === caso.id ? '0.4' : '1'"
          [style.cursor]="!caso.reversable ? 'not-allowed' : 'pointer'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">undo</mat-icon>
          Devolverle el saldo
        </button>

        <button (click)="repuestoAMano(caso)" [disabled]="procesando === caso.id"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: white; color: #1C593D; border: 1px solid #1C593D; border-radius: 8px; font-size: 0.82rem; font-weight: 700; cursor: pointer;"
          [style.opacity]="procesando === caso.id ? '0.4' : '1'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">done_all</mat-icon>
          Ya le pagué a mano
        </button>

        <button (click)="descartar(caso)" [disabled]="procesando === caso.id"
          style="display: inline-flex; align-items: center; gap: 6px; padding: 8px 16px; background: #f3f4f6; color: #4b5563; border: none; border-radius: 8px; font-size: 0.82rem; font-weight: 600; cursor: pointer;"
          [style.opacity]="procesando === caso.id ? '0.4' : '1'">
          <mat-icon style="font-size: 16px; width: 16px; height: 16px;">visibility_off</mat-icon>
          Descartar
        </button>

        <span *ngIf="procesando === caso.id" style="display: inline-flex; align-items: center; gap: 8px; font-size: 0.8rem; color: #6b7280;">
          <mat-spinner diameter="16"></mat-spinner> Procesando...
        </span>
      </div>
    </div>
  </div>

  <div style="display: flex; justify-content: flex-end; padding: 16px 24px; border-top: 1px solid #e5e7eb;">
    <button (click)="cerrar()"
      style="padding: 10px 24px; background: #f3f4f6; color: #374151; border: none; border-radius: 8px; font-size: 0.9rem; font-weight: 600; cursor: pointer;">
      Cerrar
    </button>
  </div>

</div>
